module.exports = __webpack_public_path__ + "static/aileen-f0bd6d3e4240639ef81ada15d1c5cedc.jpg";